import { Mail } from "lucide-react";
import { Input } from "../ui";

export function EmailField({ value, onChange, error, autoFocus, disabled }: { value: string; onChange: (value: string) => void; error?: string; autoFocus?: boolean; disabled?: boolean }) {
  return (
    <Input
      label="Email address"
      type="email"
      icon={Mail}
      size="lg"
      autoComplete="email"
      autoFocus={autoFocus}
      disabled={disabled}
      placeholder="you@example.com"
      value={value}
      error={error}
      onChange={(event) => onChange(event.target.value)}
    />
  );
}

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Checked before asking the server, so a typo is caught where it was made. */
export function emailProblem(value: string): string | undefined {
  if (!value.trim()) return "Enter your email address";
  if (!EMAIL.test(value.trim())) return "That doesn't look like an email address. Check for a typo";
}
